import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchModuleAuthorization = async (moduleId) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=authorizedForModule&companyid=${user.companyid}&moduleId=${moduleId}&userType=${user.usertype}`,
  );

  return response.data;
};

const useModuleAuthorizationQuery = (moduleId, options = {}) => {
  return useQuery({
    queryKey: ["moduleAuthorization", moduleId],
    queryFn: () => fetchModuleAuthorization(moduleId),
    enabled: !!moduleId && options.enabled !== false,
    retry: false,
    ...options,
  });
};

export default useModuleAuthorizationQuery;
